
import {filter} from 'rxjs/operators';
import {Directive, ElementRef, Inject, Input, OnDestroy, OnInit} from "@angular/core";
import {
	WINDOW_LISTENER_TOKEN, WindowEvent,
	WindowHostListenerService
} from "../../../window/window.host.listener.service";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Directive({
	selector: '[cpScrollTo]',
})
export class ScrollToDirective implements OnInit, OnDestroy {

	@Input() selector: string;

	private readonly ARROW_UP_KEY: number = 38;
	private readonly ARROW_DOWN_KEY: number = 40;
	private readonly HOME_KEY: number = 36;
	private readonly END_KEY: number = 35;

	constructor(@Inject(WINDOW_LISTENER_TOKEN) private windowHostListenerService: WindowHostListenerService,
				private elementRef: ElementRef) {
	}

	public ngOnInit() {
		this.windowHostListenerService.getObservable<KeyboardEvent>(WindowEvent.keyup).pipe(
			filter((event) =>
				event.keyCode === this.ARROW_UP_KEY || event.keyCode === this.ARROW_DOWN_KEY ||
				event.keyCode === this.HOME_KEY || event.keyCode === this.END_KEY))
			.pipe(untilDestroyed(this))
			.subscribe(() => {
				let element = this.elementRef.nativeElement;
				let target = element.querySelector(this.selector);

				if (target) {
					let elementRects = element.getClientRects()[0];
					let targetRects = target.getClientRects()[0];

					let scrollTo = targetRects.top - elementRects.top + element.scrollTop;

					//Update the scroll only if the target item is not visible.
					if (scrollTo <= element.scrollTop || (scrollTo - element.scrollTop) >= elementRects.height) {
						element.scrollTop = scrollTo;
					}
				}
			});
	}

	public ngOnDestroy(): void {
	}
}
